import script from "./Invoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./Invoices.vue?vue&type=script&setup=true&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=622e6012&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622e6012"]])

export default __exports__